import axios from "axios";
import { Eye, Feather, Sunrise } from "lucide-react";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const getToken = () => localStorage.getItem("ef_access_token");
const getRefresh = () => localStorage.getItem("ef_refresh_token");

export const saveTokens = (access, refresh) => {
  if (access) localStorage.setItem("ef_access_token", access);
  if (refresh) localStorage.setItem("ef_refresh_token", refresh);
};

export const clearTokens = () => {
  localStorage.removeItem("ef_access_token");
  localStorage.removeItem("ef_refresh_token");
};

export const API = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  withCredentials: true
});

API.interceptors.request.use((config) => {
  const token = getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

API.interceptors.response.use(
  res => res,
  async error => {
    const original = error.config;
    if (error.response?.status === 401 && !original._retry && !original.url?.includes('/auth/')) {
      original._retry = true;
      const refresh = getRefresh();
      if (refresh) {
        try {
          const { data } = await axios.post(`${BACKEND_URL}/api/auth/refresh`, {}, {
            withCredentials: true,
            headers: { "X-Refresh-Token": refresh }
          });
          if (data.access_token) {
            saveTokens(data.access_token, null);
            original.headers.Authorization = `Bearer ${data.access_token}`;
          }
          return API(original);
        } catch {
          clearTokens();
          window.location.href = '/logga-in';
          return Promise.reject(error);
        }
      }
      clearTokens();
      window.location.href = '/logga-in';
    }
    return Promise.reject(error);
  }
);

export const IMAGES = {
  hero_background: "https://images.unsplash.com/photo-1765498069278-77afd07c6ec9?w=1600",
  logo: "https://customer-assets.emergentagent.com/job_inre-ro-metoden/artifacts/ie5nm9nb_Fja%CC%88ril%20och%20hja%CC%88rta.png"
};

export const MOVEMENT_ICONS = [Eye, Feather, Sunrise];

export const formatError = (error) => {
  const detail = error.response?.data?.detail;
  if (!detail) return error.message || "Något gick fel";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map(e => e.msg || JSON.stringify(e)).join(" ");
  return String(detail);
};
